class AdminResponse {
    constructor( user_Id,createdForIds,created_For,first_Name,last_Name,date_of_birth,gender,is_Paid,religionid,
        religion,casteIds,caste,mother_TongueIds,mother_Tongue,role,isPaid,lookUpId) 
        {
    
        this.user_Id = user_Id;
        this.createdForIds = createdForIds;
        this.created_For = created_For;
        this.first_Name = first_Name;
        this.last_Name = last_Name;
        this.date_of_birth = date_of_birth;
        this.gender = gender;
        this.is_Paid = is_Paid;
        this.religionid = religionid;
        this.religion = religion;
        this.casteIds = casteIds;
        this.caste = caste;
        this.mother_TongueIds = mother_TongueIds;
        this.mother_Tongue = mother_Tongue;
        this.role = role;
        this.isPaid = isPaid;
        this.lookUpId = lookUpId;


    }
    static fromJson(json) {
        return new AdminResponse(
            json.user_Id,   
            json.createdForIds,
            json.created_For,
            json.first_Name,
            json.last_Name,
            json.date_of_birth,
            json.gender,
            json.is_Paid,
            json.religionid,
            json.religion,
            json.casteIds,
            json.caste,
            json.mother_TongueIds,
            json.mother_Tongue,
            json.role,
            json.isPaid,
            json.lookUpId

           
        );
    }
}

export default AdminResponse;